import {Component} from '@angular/core';
import {ViewController} from 'ionic-angular';
import {rsActivitySvc} from '../../../../../services/activity.service';

@Component({
    template: `
        <ion-list>
            <ion-list-header color="dark">Preset Titles</ion-list-header>
            <button ion-button full color="light" *ngFor="let x of titleList" (click)="selectItem(x)">{{x}}</button>
        </ion-list>
    `,
    providers : [ 
        rsActivitySvc
    ]
})
export class ActivityPopover {

    // Declare our preset title list
    private titleList : string[];

    constructor( 
        public viewCtrl : ViewController,
        private activitySvc : rsActivitySvc 
    ) {
        // Assign our title list to our preset list
        this.titleList = activitySvc.getActivityTitlePresets();
    }
    
    selectItem(item : string) {
        this.viewCtrl.dismiss({
            selected: item
        });
    }
}
    


// WEBPACK FOOTER //
// ./src/pages/report/tab-main/activity/activity-popover/activity-popover.component.ts